<template>
    <template v-if="assistant.visible">
        <v-btn @click="NewSession" variant="outlined" color="white" v-if="assistant.chats.length" size="small" class="mr-2" style="opacity:0.85; border-color: rgba(255,255,255,0.4)">New Session</v-btn>
        <v-btn @click="ChangeTheme('light')" title="Click for Light theme" v-if="assistant.theme=='dark'" size="small" icon="mdi-brightness-4" variant="text" color="white" elevation="0"/>
        <v-btn @click="ChangeTheme('dark')" title="Click for Dark theme" v-else size="small" icon="mdi-white-balance-sunny" variant="text" color="white" elevation="0"/>
    </template>
    <v-btn @click="ToggleChatUI" v-if="assistant.visible" size="small" icon="mdi-close" variant="text" color="white" elevation="0"/>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { assistant } = storeToRefs(store)

function NewSession() {
    if (confirm('Start a new session?')) {
        const updated = { ...assistant.value, chats: [] }
        store.SetAnyState({ target: 'assistant', value: updated })
    }
}

function ChangeTheme(theme: string) {
    const updated = { ...assistant.value, theme }
    store.SetAnyState({ target: 'assistant', value: updated })
}

const { ToggleChatUI } = store
</script>
